.emptyState {
  justify-content: center;
  align-items: center;
  display: flex;
}

.emptyText {
  text-align: center;
}

.dropSpacer {
  height: 4px;
}
